import React from 'react';
import './styles.css';
import { mascaraCpf } from '../../modulos/mascaraCpf/index';
import { Button } from '@material-ui/core';
import { ProgressSpinner } from 'primereact/progressspinner';

export const inscricaoBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Inscrição</span>
        {rowData.inscricao}
    </React.Fragment>
);

export const nomeBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Nome</span>
        {rowData.nome}
    </React.Fragment>
);

export const telefoneBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Data</span>
        {rowData.telefone}

    </React.Fragment>
);

export const CPFBodyTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">CPF</span>
        {mascaraCpf(rowData.cpf)}
    </React.Fragment>
);

export const vendedorBody = rowData => (
    <React.Fragment>
        <span className="p-column-title">Vendedor</span>
        {rowData.Vendedore && rowData.Vendedore.Nome}
    </React.Fragment>
);

export const subGrupoTemplate = rowData => (
    <React.Fragment>
        <span className="p-column-title">Vendedor</span>
        {rowData.statusAceite === 'MIGRADO' ?
            rowData.subGrupoDestino :
            (rowData.subGrupoOrigem ?? rowData.subGrupo)
        }
    </React.Fragment>
);

export const ButtonBodyTemplate = () => (
    <div className='datatable-editar'>
        <Button variant="text" color="primary" onClick={''}>
            Planos compatível
        </Button>
    </div>
);

export const statusBodyTemplate = rowData => (
    <div className='datatable-editar'>
        <React.Fragment>
            <span className="p-column-title">Status</span>
            {rowData.status || 'N/A'}
        </React.Fragment>
    </div>
);

export const statusAceiteBodyTemplate = rowData => (
    <div className='datatable-editar'>
        <React.Fragment>
            <span className="p-column-title">status Aceite</span>
            {rowData.statusAceite || 'N/A'}
        </React.Fragment>
    </div>
);

export const ProgressSrinnerUpSell = () => (
    <div>
        <ProgressSpinner
            style={{
                width: '300px',
                height: '150px',
                display: 'flex',
                marginTop: '8%'
            }}
            strokeWidth="1"
            fill="#EEEEEE"
            animationDuration=".5s"
        />
    </div>
);
